import React from 'react';
import { FDIcon } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('SortButton', () => ({
  sort: {
    display: 'inline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export function SortButton({
  column, sortBy, setSortBy, sortAscending, setSortAscending,
}) {
  const classes = useStyles();
  const toggleSortOn = () => {
    if (sortBy === column) {
      setSortAscending(!sortAscending);
      return;
    }
    setSortBy(column);
    setSortAscending(true);
  };

  return (
    <div
      className={classes.sort}
      role="button"
      tabIndex={0}
      onClick={() => toggleSortOn(column)}
      onKeyDown={e => (e.key === 'Enter' || e.keyCode === 13 ? toggleSortOn(column) : undefined)}
    >
      <FDIcon icon="sort" size="sm" />
    </div>
  );
}
